<template>
    <div class="layout-general-colors space-y-5 lg:space-y-10 xl:space-y-14">
        <div class="uppercase font-semibold">
            {{ $t('layout.color.settings') }}
        </div>
        <div class="layout-general-colors__colors space-y-5 lg:space-y-10 xl:space-y-14">
            <RedesignVerticalFormItem
                v-for="colorParameter in colorParameters"
                :key="colorParameter.LayoutParameterName"
                :title="getLayoutConfigParameterTranslation(colorParameter.LayoutParameterName)"
                :description="getLayoutConfigParameterInfoTranslation(colorParameter.LayoutParameterName)"
                class="layout-general-colors__color"
            >
                <LayoutSettingsColorPicker
                    v-model="colorParameter.Value"
                    :color-name="colorParameter.LayoutParameterName"
                />
            </RedesignVerticalFormItem>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ILayoutItem } from '@/types/dashboard'
import { useVModel } from '@vueuse/core'
import { computed } from 'vue'
import RedesignVerticalFormItem from '@/components/RedesignBaseComponents/Form/RedesignVerticalFormItem.vue'
import LayoutSettingsColorPicker from '@/components/RedesignComponents/Layout/Common/LayoutSettingsColorPicker.vue'
import { getLayoutConfigParameterInfoTranslation, getLayoutConfigParameterTranslation } from '@/helpers/translation'
import { DEFAULT_LAYOUT_GENERAL_COLORS } from '@/enum/layout'
import { getFilteredLayoutParameters } from '@/enum/default-layout-config'

const props = defineProps<{
    value: ILayoutItem
}>()
const emit = defineEmits<{
    (e: 'input', value: ILayoutItem): void
    (e: 'update:value', value: ILayoutItem): void
}>()

const layoutLocalModel = useVModel(props, 'value', emit, { eventName: 'input' })

const colorParameters = computed(() => {
    return getFilteredLayoutParameters(layoutLocalModel.value?.LayoutParametersList || [], DEFAULT_LAYOUT_GENERAL_COLORS)
})
</script>
